import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Team from "@/pages/Team";
import Journal from "@/pages/Journal";
import JournalArticle from "@/pages/JournalArticle";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Portfolio from "@/pages/Portfolio";
import { I18nProvider } from "@/i18n/I18nProvider";

const TOAST_OPTIONS = {
  style: {
    background: "#ffffff",
    border: "1px solid #e5e5e5",
    color: "#121212",
    fontFamily: "Manrope, sans-serif",
  },
};

export default function App() {
  return (
    <div className="App">
      <I18nProvider>
        <BrowserRouter>
          <Toaster
            theme="light"
            position="top-right"
            toastOptions={TOAST_OPTIONS}
          />
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="servizi" element={<Services />} />
              <Route path="studio" element={<Team />} />
              <Route path="portfolio" element={<Portfolio />} />
              <Route path="journal" element={<Journal />} />
              <Route path="journal/:slug" element={<JournalArticle />} />
              <Route path="contatti" element={<Contact />} />
              <Route path="admin" element={<Admin />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </I18nProvider>
    </div>
  );
}
